// extracted by mini-css-extract-plugin
export default {"container":"ServicesCard_container__aDZiK","red":"ServicesCard_red__KtOnq"};